import React, { FC } from 'react';
import _ from 'lodash';
import { useHeaderContext } from '@components/Contexts/HeaderContext';
import { useBiSessionContext } from '@components/Contexts/BiSessionContext';
import Header from '@components/Header';

const TemplateGalleryPageHeader: FC = () => {
  const { sessionId } = useBiSessionContext();

  return (
    <Header onClick={() => {}} pageName="templates" sessionId={sessionId} />
  );
};

export default TemplateGalleryPageHeader;
